module.exports = __webpack_public_path__ + "static/media/home.8408012a.png";